import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";

import { useParams } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Chip,
  CircularProgress,
  Divider,
  Button,
  Link,
  Paper,
  List,
  Avatar,
  AvatarGroup,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Stack,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Badge,
  CardActions,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  LinearProgress,
} from "@mui/material";
import {
  LocationOn as LocationIcon,
  AccessTime as TimeIcon,
  Groups as GroupsIcon,
  CalendarToday as CalendarIcon,
  ExpandMore as ExpandMoreIcon,
  Route as RouteIcon,
  RequestPage as RequestIcon,
  CheckCircle as CheckIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  Star as StarIcon,
  LocalShipping as TruckIcon,
  Schedule as ScheduleIcon,
  Event as EventIcon,
  Whatshot as FireIcon,
  EmojiEvents as TrophyIcon,
  FlashOn as FlashIcon,
  Sync as SyncIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import HailIcon from "@mui/icons-material/Hail";

import { format, addHours } from "date-fns";
import axiosInstance from "../utils/axios";
import { useAuth } from "../contexts/AuthContext";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { keyframes } from "@emotion/react";
dayjs.extend(utc);

const SpecialEvent = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [event, setEvent] = useState(null);
  const [routeSlots, setRouteSlots] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // const [selectedRoute, setSelectedRoute] = useState(0);
  const [requestDialogOpen, setRequestDialogOpen] = useState(false);

  const [requestForm, setRequestForm] = useState({
    vtcName: "",
    vtcRole: "",
    vtcLink: "",
    playercount: "",
    discordUsername: "",
    DL: "",
    truck: "",
    trailer: "",
    notes: "",
  });
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestSuccess, setRequestSuccess] = useState(false);
  const [myRequest, setMyRequest] = useState(null);
  const [expandedSlots, setExpandedSlots] = useState({});
  const [routeRequests, setRouteRequests] = useState({});
  const [tmpdata, Settmpdata] = useState(null);
  const theme = useTheme();
  const [zoomed, setZoomed] = useState(false);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [imagePreviewRoute, setImagePreviewRoute] = useState(null);
  const [imagePreviewIndex, setImagePreviewIndex] = useState(0);
  const [selectedRoute, setSelectedRoute] = useState(0);
   const getRouteImages = (routeName) =>
    (routeSlots[routeName] || [])
      .filter((s) => s.imageUrl)
      .map((s) => s.imageUrl);

  const normalizeId = (id) => {
    if (!id) return "";
    if (typeof id === "object" && id._id) return String(id._id);
    return String(id);
  };

  const getSlotAllocations = (slot) => {
    const slotId = normalizeId(slot._id);
    return Object.values(routeRequests)
      .flat()
      .filter((request) => {
        if (request.status !== "approved") return false;
        if (normalizeId(request.allocatedSlotId) === slotId) return true;
        return (
          request.routeName === slot.routeName &&
          request.allocatedSlotNumber === slot.slotNumber
        );
      });
  };

  const getSlotPendingRequests = (slot) => {
    const slotId = normalizeId(slot._id);
    return Object.values(routeRequests)
      .flat()
      .filter((request) => {
        if (request.status !== "pending") return false;
        if (normalizeId(request.allocatedSlotId) === slotId) return true;
        return (
          request.routeName === slot.routeName &&
          request.allocatedSlotNumber === slot.slotNumber
        );
      });
  };

const shine = keyframes`
  from {
    background-position: 0% center;
  }
  to {
    background-position: 200% center;
  }
`;

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;

      try {
        setLoading(true);
        setError("");

        // Fetch special event
        const specialEventRes = await axiosInstance.get(
          `/special-events/${id}`
        );
        console.log(specialEventRes);//gobi
        setEvent(specialEventRes.data.event);

        setRouteSlots(specialEventRes.data.routeSlots);

        // Set route requests for allocation display
        if (specialEventRes.data.routeRequests) {
          setRouteRequests(specialEventRes.data.routeRequests);
          const storedVtc = sessionStorage.getItem(`special-event-request-vtc-${id}`);
          if (storedVtc) {
            const allReqs = Object.values(specialEventRes.data.routeRequests).flat();
            const match = allReqs.find((r) => r.vtcName === storedVtc);
            if (match) setMyRequest(match);
          }
        } else {
          console.log("No route requests found in response");
        }

        if (specialEventRes.data.event.routes.length > 0) {
          setSelectedRoute(0);
        }

        // Fetch event details
        const eventDetailsRes = await axiosInstance.get(`/events/${id}`);

        Settmpdata(eventDetailsRes.data);
      } catch (error) {
        console.error("Error fetching event data:", error);
        setError("Failed to load event details");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleRequestRoute = () => {
    setRequestForm({
      vtcName: "",
      vtcRole: "",
      playercount: 1,
      discordUsername: "",
      DL: "",
      vtcLink: "",
      notes: "",
    });
    setRequestDialogOpen(true);
  };

  const handleSubmitRequest = async () => {
    try {
      setRequestLoading(true);
      setError("");

      const requestData = {
        vtcName: requestForm.vtcName,
        vtcRole: requestForm.vtcRole,
        playercount: parseInt(requestForm.playercount),
        discordUsername: requestForm.discordUsername,
        vtcLink: requestForm.vtcLink,
        notes: requestForm.notes,
        DL: requestForm.DL,
      };

      // Submit general request (admin will allocate to route and slot)
      const response = await axiosInstance.post(
        `/special-events/${event.truckersmpId}/request`,
        requestData
      );

      console.log("Request submitted successfully:", response.data);
      console.log("Request details:", {
        eventId: event.truckersmpId,
        routeName: event.routes[selectedRoute].name,
        requestData: requestData,
        response: response.data,
      });
      setRequestSuccess(true);
      if (response.data?.request) {
        setMyRequest(response.data.request);
        sessionStorage.setItem(
          `special-event-request-vtc-${event.truckersmpId}`,
          requestForm.vtcName
        );
      }

      // Close dialog and reset form
      setRequestDialogOpen(false);
      setRequestForm({
        vtcName: "",
        vtcRole: "",
        playercount: 1,
        discordUsername: "",
        vtcLink: "",
        notes: "",
      });

      // Refresh event data to show updated request count
      console.log("Refreshing event data after request submission...");
      const eventResponse = await axiosInstance.get(`/special-events/${id}`);
      console.log("Refreshed event data:", eventResponse.data);
      console.log("Route slots:", eventResponse.data.routeSlots);
      console.log("Route requests:", eventResponse.data.routeRequests);
      setEvent(eventResponse.data.event);
      setRouteSlots(eventResponse.data.routeSlots);
      if (eventResponse.data.routeRequests) {
        setRouteRequests(eventResponse.data.routeRequests);
        const storedVtc = sessionStorage.getItem(`special-event-request-vtc-${id}`);
        if (storedVtc) {
          const allReqs = Object.values(eventResponse.data.routeRequests).flat();
          const match = allReqs.find((r) => r.vtcName === storedVtc);
          if (match) setMyRequest(match);
        }
      }
    } catch (error) {
      console.error("Error submitting request:", error);
      setError(error.response?.data?.message || "Failed to submit request");
    } finally {
      setRequestLoading(false);
    }
  };

  const getSlotStatusColor = (slot) => {
    if (slot.status === "assigned") return "success";
    if (slot.status === "requested") return "warning";
    if (slot.status === "closed") return "error";
    return "default";
  };

  const getSlotStatusText = (slot) => {
    if (slot.status === "assigned") return "Assigned";
    if (slot.status === "requested") return "Requested";
    if (slot.status === "closed") return "Closed";
    return "Available";
  };

  const getRequestStatusIcon = (request) => {
    switch (request.status) {
      case "approved":
        return <CheckIcon color="success" />;
      case "rejected":
        return <CancelIcon color="error" />;
      case "pending":
        return <PendingIcon sx={{ color: "#FF9800" }} />;
      default:
        return <InfoIcon />;
    }
  };

  const getRequestStatusColor = (request) => {
    switch (request.status) {
      case "approved":
        return "success";
      case "rejected":
        return "error";
      case "pending":
        return "warning";
      default:
        return "default";
    }
  };

  const toggleSlotExpansion = (slotId) => {
    setExpandedSlots((prev) => ({
      ...prev,
      [slotId]: !prev[slotId],
    }));
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 6,
          }}
        >
          <CircularProgress
            size={60}
            sx={{
              color: "#FFD700",
              mb: 3,
            }}
          />
          <Typography
            variant="h5"
            sx={{
              color: "#F57C00",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 600,
            }}
          >
            🌟 Loading Special Event...
          </Typography>
          <LinearProgress
            sx={{
              width: "100%",
              maxWidth: 400,
              mt: 2,
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#FFD700",
              },
            }}
          />
        </Box>
      </Container>
    );
  }

  if (error || !event) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor:
            theme.palette.mode === "dark" ? "#0f0f0f" : "#fafafa",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          padding: "20px",
        }}
      >
        <div
          style={{
            maxWidth: "480px",
            width: "100%",
            textAlign: "center",
            background: theme.palette.mode === "dark" ? "#1a1a1a" : "#ffffff",
            borderRadius: "8px",
            padding: "48px 32px",
            boxShadow:
              theme.palette.mode === "dark"
                ? "0 1px 3px rgba(255, 255, 255, 0.05)"
                : "0 1px 3px rgba(0, 0, 0, 0.1)",
            border:
              theme.palette.mode === "dark"
                ? "1px solid #2a2a2a"
                : "1px solid #e5e7eb",
            animation: "fadeIn 0.4s ease-out",
          }}
        >
          {/* Status Icon */}
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor:
                theme.palette.mode === "dark" ? "#2563eb" : "#3b82f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              animation: "pulse 2s ease-in-out infinite",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "50%",
                backgroundColor: "white",
              }}
            />
          </div>

          {/* Main Message */}
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: theme.palette.mode === "dark" ? "#ffffff" : "#111827",
              marginBottom: "8px",
              lineHeight: "1.3",
            }}
          >
            Event Details Coming Soon
          </h1>

          {/* Subtitle */}
          <p
            style={{
              fontSize: "16px",
              color: theme.palette.mode === "dark" ? "#9ca3af" : "#6b7280",
              marginBottom: "32px",
              lineHeight: "1.5",
              fontWeight: "400",
            }}
          >
            We're working on something special for this event. Check back soon
            for all the exciting details.
          </p>

          {/* Loading Bar */}

          {/* Back Button */}
          <button
            onClick={() => window.history.go(-2)}
            style={{
              backgroundColor: "transparent",
              color: theme.palette.mode === "dark" ? "#9ca3af" : "#6b7280",
              fontWeight: "500",
              fontSize: "14px",
              border: `1px solid ${
                theme.palette.mode === "dark" ? "#374151" : "#d1d5db"
              }`,
              borderRadius: "6px",
              padding: "10px 16px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor =
                theme.palette.mode === "dark" ? "#4b5563" : "#9ca3af";
              e.target.style.color =
                theme.palette.mode === "dark" ? "#d1d5db" : "#374151";
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor =
                theme.palette.mode === "dark" ? "#374151" : "#d1d5db";
              e.target.style.color =
                theme.palette.mode === "dark" ? "#9ca3af" : "#6b7280";
            }}
          >
            <span>←</span>
            Go Back
          </button>
        </div>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes drive {
            0% {
              transform: translateX(-10%);
            }
            100% {
              transform: translateX(110%);
            }
          }
        `}</style>
      </div>
    );
  }


  const previewImages = imagePreviewRoute
    ? getRouteImages(imagePreviewRoute)
    : [];

  const approvedBookings = Object.entries(routeRequests).flatMap(
    ([routeName, requests]) =>
      (requests || [])
        .filter((r) => r.status === "approved")
        .map((r) => ({
          ...r,
          routeName: r.routeName || routeName,
        }))
  );

  const totalSlotCapacity = Object.values(routeSlots).flat().reduce(
    (sum, slot) => sum + (slot.maxVtc || 0),
    0
  );
  const totalAvailable = Object.values(routeSlots).flat().reduce(
    (sum, slot) => sum + (slot.maxVtc - (slot.allocatedVtcs || 0)),
    0
  );
  const totalBooked = Object.values(routeSlots).flat().reduce(
    (sum, slot) => sum + (slot.allocatedVtcs || 0),
    0
  );

  const getSlotStatusLabel = (slot) => {
    const remaining = slot.maxVtc - (slot.allocatedVtcs || 0);
    if (remaining <= 0) return "Full";
    if (slot.allocatedVtcs > 0) return "Partial";
    return "Open";
  };

  const getSlotStatusChipColor = (slot) => {
    const label = getSlotStatusLabel(slot);
    if (label === "Open") return "success";
    if (label === "Partial") return "warning";
    return "default";
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 25%, #16213e 50%, #0f3460 75%, #533483 100%)",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 20%, rgba(255, 215, 0, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 152, 0, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      
      <Container
        maxWidth={false}
        sx={{ pt: 4, pb: 8, position: "relative", zIndex: 1 }}
      >
        {/* Floating Specialty Badges */}
        <Box
          sx={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        ></Box>
        
        {/* Enhanced Event Header */}
        <Paper
          elevation={0}
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: 3,
            mb: 4,
            background: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(255, 215, 0, 0.1)",
            transition: "all 0.3s ease",
            "&:hover": {
              border: "1px solid rgba(255, 215, 0, 0.2)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "3px",
              backgroundSize: "300% 100%",
              animation: "flow 4s ease-in-out infinite",
              "@keyframes flow": {
                "0%, 100%": { backgroundPosition: "0% 50%" },
                "50%": { backgroundPosition: "100% 50%" },
              },
            },
          }}
        >
          {/* <Box>Hello</Box> */}
          <Box
            component="header"
            sx={{
              maxWidth: "1280px", // max-w-7xl
              mx: "auto",
              py: 6,
              px: 2,
              textAlign: "center",
            }}
          >
             <Typography variant="h4"
      sx={{
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.18em",
        color: "transparent",
        WebkitTextFillColor: "transparent",

        backgroundImage: `
          linear-gradient(
            90deg,
            #B8860B 0%,     /* Dark Gold */
            #C89B0E 30%,    /* Gold */
            #FFF1A8 50%,    /* Bright moving shine */
            #C89B0E 70%,    /* Gold */
            #B8860B 100%    /* Dark Gold */
          )
        `,
        backgroundSize: "80%",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",

        animation: `${shine} 8s linear infinite`,
      }}
    >
      {event.title}
    </Typography>
            {/* Details */}
            <Box 
              sx={{
                mt: 2,
                fontSize: {
                  xs: "1rem",
                  sm: "1.125rem",
                  md: "1.25rem",
                },
                lineHeight: 1.7,
                letterSpacing: "0.1em",
                background: "linear-gradient(135deg, #FFD700 0%, #ffd000 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              <Typography component="p" sx={{ mb: 0.5 }} >
                <Box
                  component="strong"
                  sx={{ fontWeight: 700, letterSpacing: "0.15em" }}
                >
                  DATE:
                </Box>{" "}
                {event?.startDate
                ? format(new Date(event.startDate), "do MMMM yyyy")
                : "-"}
              </Typography>

              <Typography component="p" sx={{ mb: 0.5 }}>
                <Box
                  component="strong"
                  sx={{ fontWeight: 700, letterSpacing: "0.15em" }}
                >
                  SERVER:
                </Box>{" "}
                {event.server}
              </Typography>

              <Typography component="p">
                <Box
                  component="strong"
                  sx={{ fontWeight: 700, letterSpacing: "0.15em" }}
                >
                  DEPT. TIME:
                </Box>{" "}
                {`${format(new Date(event.startDate), "HH:mm")} UTC`}
              </Typography>
            </Box>
          </Box>
          
        
        </Paper>

        {event.description && (
          <Accordion
            defaultExpanded={false}
            elevation={0}
            sx={{
              mb: 4,
              borderRadius: "8px !important",
              background: "rgba(0, 0, 0, 0.35)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#FFD700" }} />}
              sx={{ px: 2 }}
            >
              <Typography sx={{ fontWeight: 600, color: "rgba(255,255,255,0.95)" }}>
                Event details
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                px: 3,
                pt: 0,
                pb: 3,
                "& p": { color: "rgba(255,255,255,0.8)", lineHeight: 1.7, mb: 1 },
                "& strong": { color: "#FFD700" },
              }}
            >
              <ReactMarkdown>{event.description}</ReactMarkdown>
            </AccordionDetails>
          </Accordion>
        )}

        {/* Routes & slots — one section per route */}
        {event?.routes?.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              sx={{ color: "rgba(255,255,255,0.95)", fontWeight: 600, mb: 3 }}
            >
              Routes &amp; slots
            </Typography>

            {event.routes.map((route) => {
              const slots = (routeSlots[route.name] || []).sort(
                (a, b) => a.slotNumber - b.slotNumber
              );
              const routeColor = route.color || "#FFD700";
              const slotsWithImages = slots.filter((s) => s.imageUrl);
              const availableSpots = slots.reduce(
                (sum, slot) => sum + (slot.maxVtc - (slot.allocatedVtcs || 0)),
                0
              );

              return (
                <Accordion
                  key={route.name}
                  defaultExpanded={false}
                  elevation={0}
                  sx={{
                    mb: 2,
                    borderRadius: "8px !important",
                    background: "rgba(0, 0, 0, 0.35)",
                    border: "1px solid rgba(255, 255, 255, 0.08)",
                    "&:before": { display: "none" },
                    overflow: "hidden",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: routeColor }} />}
                    sx={{
                      px: 2,
                      borderLeft: `4px solid ${routeColor}`,
                      "& .MuiAccordionSummary-content": { my: 1.5 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                        width: "100%",
                        pr: 1,
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 700, color: "#fff" }}>
                        {route.name}
                      </Typography>
                      <Chip
                        label={`${slots.length} slot${slots.length !== 1 ? "s" : ""}`}
                        size="small"
                        sx={{
                          bgcolor: `${routeColor}22`,
                          color: routeColor,
                          border: `1px solid ${routeColor}55`,
                          fontWeight: 600,
                        }}
                      />
                      {slots.length > 0 && (
                        <Chip
                          label={`${availableSpots} open`}
                          size="small"
                          variant="outlined"
                          sx={{
                            color: availableSpots > 0 ? "#4CAF50" : "rgba(255,255,255,0.5)",
                            borderColor: availableSpots > 0 ? "#4CAF5044" : "rgba(255,255,255,0.15)",
                            fontWeight: 500,
                          }}
                        />
                      )}
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails sx={{ p: 0 }}>
                    {route.description && (
                      <Box sx={{ px: 3, pt: 1, pb: 2 }}>
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(255,255,255,0.75)", lineHeight: 1.6 }}
                        >
                          {route.description}
                        </Typography>
                      </Box>
                    )}

                  {slots.length > 0 ? (
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ bgcolor: "rgba(255, 255, 255, 0.05)" }}>
                            <TableCell sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 600, width: 48 }}>
                              #
                            </TableCell>
                            <TableCell sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 600 }}>
                              Slot
                            </TableCell>
                            <TableCell sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 600 }}>
                              Details
                            </TableCell>
                            <TableCell sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 600 }} align="center">
                              Available
                            </TableCell>
                            <TableCell sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 600 }} align="center">
                              Status
                            </TableCell>
                            <TableCell sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 600 }}>
                              Assigned VTCs
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {slots.map((slot, index) => {
                            const allocated = getSlotAllocations(slot);
                            const pending = getSlotPendingRequests(slot);
                            const remaining = slot.maxVtc - (slot.allocatedVtcs || 0);

                            return (
                              <TableRow
                                key={slot._id || index}
                                sx={{
                                  "&:nth-of-type(even)": { bgcolor: "rgba(255,255,255,0.02)" },
                                  "&:hover": { bgcolor: "rgba(255,255,255,0.04)" },
                                }}
                              >
                                <TableCell sx={{ color: "rgba(255,255,255,0.5)", fontWeight: 600 }}>
                                  {slot.slotNumber}
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2" sx={{ color: "#fff", fontWeight: 600 }}>
                                    {slot.slotName || `Slot ${slot.slotNumber}`}
                                  </Typography>
                                  {slot.imageUrl && (
                                    <Button
                                      size="small"
                                      startIcon={<VisibilityIcon />}
                                      onClick={() => {
                                        setImagePreviewRoute(route.name);
                                        setImagePreviewIndex(
                                          slotsWithImages.findIndex((s) => s._id === slot._id)
                                        );
                                        setImagePreviewOpen(true);
                                      }}
                                      sx={{
                                        mt: 0.5,
                                        color: routeColor,
                                        textTransform: "none",
                                        p: 0,
                                        minWidth: 0,
                                      }}
                                    >
                                      View map
                                    </Button>
                                  )}
                                </TableCell>
                                <TableCell sx={{ color: "rgba(255,255,255,0.7)", maxWidth: 300 }}>
                                  <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                                    {slot.description || "—"}
                                  </Typography>
                                  {slot.specialRequirements?.length > 0 && (
                                    <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 1 }}>
                                      {slot.specialRequirements.map((req, idx) => (
                                        <Chip
                                          key={idx}
                                          label={req}
                                          size="small"
                                          variant="outlined"
                                          sx={{
                                            fontSize: "0.7rem",
                                            color: "rgba(255,255,255,0.6)",
                                            borderColor: "rgba(255,255,255,0.2)",
                                          }}
                                        />
                                      ))}
                                    </Stack>
                                  )}
                                </TableCell>
                                <TableCell align="center" sx={{ color: "#fff", whiteSpace: "nowrap" }}>
                                  {remaining}/{slot.maxVtc}
                                </TableCell>
                                <TableCell align="center">
                                  <Chip
                                    label={getSlotStatusLabel(slot)}
                                    size="small"
                                    color={getSlotStatusChipColor(slot)}
                                    sx={{ fontWeight: 600, minWidth: 72 }}
                                  />
                                  {pending.length > 0 && (
                                    <Typography
                                      variant="caption"
                                      display="block"
                                      sx={{ color: "#FF9800", mt: 0.5 }}
                                    >
                                      {pending.length} pending
                                    </Typography>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {allocated.length > 0 ? (
                                    <Stack spacing={0.5}>
                                      {allocated.map((req, idx) => (
                                        <Box
                                          key={idx}
                                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                          <CheckCircleIcon sx={{ color: "#4CAF50", fontSize: 16 }} />
                                          <Typography variant="body2" sx={{ color: "#fff" }}>
                                            {req.vtcName}
                                            {req.allocatedSlotName && (
                                              <Typography
                                                component="span"
                                                variant="caption"
                                                sx={{ color: "rgba(255,255,255,0.5)", ml: 1 }}
                                              >
                                                ({req.allocatedSlotName})
                                              </Typography>
                                            )}
                                          </Typography>
                                        </Box>
                                      ))}
                                    </Stack>
                                  ) : (
                                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.4)" }}>
                                      None
                                    </Typography>
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Box sx={{ px: 3, py: 4, textAlign: "center" }}>
                      <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.5)" }}>
                        No slots configured for this route.
                      </Typography>
                    </Box>
                  )}

                  {slotsWithImages.length > 0 && (
                    <Box sx={{ px: 3, py: 2, borderTop: "1px solid rgba(255,255,255,0.06)" }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "rgba(255,255,255,0.5)",
                          fontWeight: 600,
                          display: "block",
                          mb: 1.5,
                        }}
                      >
                        Slot maps
                      </Typography>
                      <Grid container spacing={2}>
                        {slotsWithImages.map((slot, imgIdx) => (
                          <Grid item xs={6} sm={4} md={3} key={slot._id}>
                            <Box
                              sx={{
                                aspectRatio: "1 / 1",
                                bgcolor: "rgba(255,255,255,0.05)",
                                borderRadius: 1,
                                border: "1px solid rgba(255,255,255,0.08)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                overflow: "hidden",
                                p: 1,
                                "&:hover": { borderColor: routeColor },
                              }}
                              onClick={() => {
                                setImagePreviewRoute(route.name);
                                setImagePreviewIndex(imgIdx);
                                setImagePreviewOpen(true);
                              }}
                            >
                              <img
                                src={slot.imageUrl}
                                alt={slot.slotName}
                                loading="lazy"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            </Box>
                            <Typography
                              variant="caption"
                              sx={{
                                display: "block",
                                mt: 0.5,
                                color: "rgba(255,255,255,0.6)",
                                textAlign: "center",
                              }}
                            >
                              {slot.slotName}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        )}

        {/* Slot image preview */}
        <Dialog
          open={imagePreviewOpen}
          onClose={() => {
            setImagePreviewOpen(false);
            setZoomed(false);
          }}
          maxWidth={false}
          PaperProps={{
            sx: {
              backgroundColor: "transparent",
              boxShadow: "none",
              overflow: "hidden",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              height: "100vh",
              width: "100vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.92)",
            }}
          >
            {previewImages.length > 0 && (() => {
              const isFirst = imagePreviewIndex === 0;
              const isLast = imagePreviewIndex === previewImages.length - 1;

              return (
                <>
                  <IconButton
                    onClick={() => {
                      setZoomed(false);
                      if (!isFirst) setImagePreviewIndex((prev) => prev - 1);
                    }}
                    disabled={isFirst}
                    sx={{
                      position: "absolute",
                      left: 15,
                      zIndex: 9999,
                      color: "white",
                      backgroundColor: "rgba(0,0,0,0.45)",
                      "&:hover": { backgroundColor: "rgba(0,0,0,0.65)" },
                      "&.Mui-disabled": {
                        color: "rgba(255,255,255,0.3)",
                        backgroundColor: "rgba(0,0,0,0.2)",
                      },
                    }}
                  >
                    <ArrowBackIosNewIcon />
                  </IconButton>

                  <Box
                    sx={{
                      maxHeight: "90vh",
                      maxWidth: "90vw",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      zIndex: 1,
                    }}
                    onClick={() => setZoomed((p) => !p)}
                  >
                    <img
                      key={imagePreviewIndex}
                      src={previewImages[imagePreviewIndex]}
                      alt="Slot map preview"
                      style={{
                        maxHeight: "90vh",
                        maxWidth: "90vw",
                        objectFit: "contain",
                        borderRadius: 8,
                        transform: zoomed ? "scale(1.6)" : "scale(1)",
                        transition: "transform 0.3s ease",
                        cursor: zoomed ? "zoom-out" : "zoom-in",
                      }}
                    />
                  </Box>

                  <IconButton
                    onClick={() => {
                      setZoomed(false);
                      if (!isLast) setImagePreviewIndex((prev) => prev + 1);
                    }}
                    disabled={isLast}
                    sx={{
                      position: "absolute",
                      right: 15,
                      zIndex: 9999,
                      color: "white",
                      backgroundColor: "rgba(0,0,0,0.45)",
                      "&:hover": { backgroundColor: "rgba(0,0,0,0.65)" },
                      "&.Mui-disabled": {
                        color: "rgba(255,255,255,0.3)",
                        backgroundColor: "rgba(0,0,0,0.2)",
                      },
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      setImagePreviewOpen(false);
                      setZoomed(false);
                    }}
                    sx={{
                      position: "absolute",
                      top: 20,
                      right: 20,
                      zIndex: 9999,
                      color: "white",
                      backgroundColor: "rgba(0,0,0,0.45)",
                    }}
                  >
                    ✕
                  </IconButton>
                </>
              );
            })()}
          </Box>
        </Dialog>

        {/* Event summary & request */}
        <Box sx={{ mb: 4 }}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              mb: 3,
              background: "rgba(0, 0, 0, 0.35)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              borderRadius: 2,
            }}
          >
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={6} md={3}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h4" sx={{ color: "#FFD700", fontWeight: 700 }}>
                    {totalSlotCapacity}
                  </Typography>
                  <Typography variant="body2" color="rgba(255,255,255,0.65)">
                    Total capacity
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} md={3}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h4" sx={{ color: "#4CAF50", fontWeight: 700 }}>
                    {totalAvailable}
                  </Typography>
                  <Typography variant="body2" color="rgba(255,255,255,0.65)">
                    Available spots
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} md={3}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h4" sx={{ color: "#FF9800", fontWeight: 700 }}>
                    {totalBooked}
                  </Typography>
                  <Typography variant="body2" color="rgba(255,255,255,0.65)">
                    Booked spots
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} md={3}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h4" sx={{ color: "#90CAF9", fontWeight: 700 }}>
                    {event.routes?.length || 0}
                  </Typography>
                  <Typography variant="body2" color="rgba(255,255,255,0.65)">
                    Routes
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ textAlign: "center", mt: 3 }}>
              {myRequest && (
                <Alert
                  severity={
                    myRequest.status === "approved"
                      ? "success"
                      : myRequest.status === "rejected"
                      ? "error"
                      : "info"
                  }
                  sx={{ mb: 2, textAlign: "left" }}
                  icon={getRequestStatusIcon(myRequest)}
                >
                  {myRequest.status === "pending" && (
                    <>
                      <strong>Request pending.</strong> Your request is pending admin allocation to a route and slot.
                      You will be notified via Discord once a decision is made.
                    </>
                  )}
                  {myRequest.status === "approved" && (
                    <>
                      <strong>Approved!</strong> You have been allocated to route{" "}
                      <strong>{myRequest.routeName}</strong>, slot{" "}
                      <strong>{myRequest.allocatedSlotName || `#${myRequest.allocatedSlotNumber}`}</strong>.
                    </>
                  )}
                  {myRequest.status === "rejected" && (
                    <>
                      <strong>Request declined.</strong>{" "}
                      {myRequest.rejectionReason
                        ? `Reason: ${myRequest.rejectionReason}`
                        : "Contact an event admin for details."}
                    </>
                  )}
                </Alert>
              )}
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleRequestRoute}
                sx={{
                  bgcolor: "#4CAF50",
                  color: "white",
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: "1rem",
                  py: 1.5,
                  px: 4,
                  borderRadius: 2,
                  "&:hover": { bgcolor: "#43a047" },
                }}
              >
                Submit slot request
              </Button>
              <Typography
                variant="body2"
                color="rgba(255,255,255,0.6)"
                sx={{ mt: 1.5, maxWidth: 480, mx: "auto" }}
              >
                Submit a request for this event. Your request stays pending until staff assigns a route and slot.
              </Typography>
            </Box>
          </Paper>
        </Box>

        {/* Enhanced No Slots Message */}
        {Object.values(routeSlots).flat().length === 0 && (
          <Paper
            elevation={0}
            sx={{
              p: 8,
              textAlign: "center",
              borderRadius: 6,
              background:
                "linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(26,26,46,0.8) 100%)",
              border: "2px solid rgba(255, 215, 0, 0.3)",
              backdropFilter: "blur(15px)",
            }}
          >
            <RouteIcon
              sx={{
                fontSize: 120,
                color: "#FFD700",
                mb: 4,
                filter: "drop-shadow(0 8px 16px rgba(255, 215, 0, 0.3))",
              }}
            />
            <Typography
              variant="h3"
              color="#FFD700"
              gutterBottom
              sx={{
                fontWeight: 800,
                mb: 3,
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
            >
              🚫 NO SLOTS AVAILABLE
            </Typography>
            <Typography
              variant="h6"
              color="rgba(255,255,255,0.8)"
              sx={{ maxWidth: 600, mx: "auto", lineHeight: 1.6 }}
            >
              No slots are currently available for this event.
              <br />
            </Typography>

            {/* Debug Button */}
          </Paper>
        )}

        {/* Enhanced Request Dialog */}
        <Dialog
          open={requestDialogOpen}
          onClose={() => setRequestDialogOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              background:
                "linear-gradient(135deg, rgba(0,0,0,0.95) 0%, rgba(26,26,46,0.95) 100%)",
              border: "2px solid rgba(255, 215, 0, 0.3)",
              backdropFilter: "blur(20px)",
              boxShadow: "0 24px 80px rgba(0,0,0,0.5)",
            },
          }}
        >
          <DialogTitle
            sx={{
              background: "linear-gradient(45deg, #FFD700 0%, #FF9800 100%)",
              color: "#000",
              fontWeight: 800,
              fontSize: "1.5rem",
              display: "flex",
              alignItems: "center",
              gap: 2,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            🎯 SUBMIT EVENT REQUEST
          </DialogTitle>

          <DialogContent sx={{ pt: 4, pb: 2 }}>
            {requestSuccess ? (
              <Alert
                severity="success"
                sx={{
                  mb: 3,
                  borderRadius: 3,
                  fontSize: "1.1rem",
                  background:
                    "linear-gradient(135deg, rgba(76, 175, 80, 0.15) 0%, rgba(102, 187, 106, 0.1) 100%)",
                  border: "2px solid rgba(76, 175, 80, 0.3)",
                  color: "#4CAF50",
                  "& .MuiAlert-icon": {
                    fontSize: "2rem",
                  },
                }}
                icon={<CheckIcon fontSize="inherit" />}
              >
                <Typography variant="h5" sx={{ fontWeight: 800, mb: 2 }}>
                  🎉 REQUEST SUBMITTED SUCCESSFULLY!
                </Typography>
                <Typography variant="body1">
                  Your event request has been submitted successfully. Your request is pending admin allocation to a route and slot.
                  You&apos;ll be notified via Discord once a decision is made.
                </Typography>
              </Alert>
            ) : (
              <Stack spacing={4} sx={{ mt: 2 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="🏢 VTC Name"
                      value={requestForm.vtcName}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          vtcName: e.target.value,
                        }))
                      }
                      fullWidth
                      required
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="👤 Your Role in VTC"
                      value={requestForm.vtcRole}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          vtcRole: e.target.value,
                        }))
                      }
                      fullWidth
                      placeholder="e.g., Owner, Manager, Member"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="🌐 VTC Link"
                      value={requestForm.vtcLink}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          vtcLink: e.target.value,
                        }))
                      }
                      fullWidth
                      placeholder="TruckersMP VTC page or website"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="👥 Number of Players"
                      value={requestForm.playercount}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          playercount: e.target.value,
                        }))
                      }
                      fullWidth
                      required
                      type="number"
                      inputProps={{ min: 1 }}
                      helperText="Number of players in your VTC"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                        "& .MuiFormHelperText-root": {
                          color: "#FFD700",
                          fontWeight: 600,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      label="💬 Discord Username"
                      value={requestForm.discordUsername}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          discordUsername: e.target.value,
                        }))
                      }
                      fullWidth
                      required
                      placeholder="Your Discord username for notifications"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                      }}
                    />
                    <TextField
                      label="VTC Discord Link (PERMANENT)"
                      value={requestForm.DL}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          DL: e.target.value,
                        }))
                      }
                      fullWidth
                      required
                      placeholder="Your Discord username for notifications"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="📝 Additional Notes"
                      value={requestForm.notes}
                      onChange={(e) =>
                        setRequestForm((prev) => ({
                          ...prev,
                          notes: e.target.value,
                        }))
                      }
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Any special requirements or additional information"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255,255,255,0.05)",
                          "& fieldset": {
                            borderColor: "rgba(255,255,255,0.3)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FFD700",
                            borderWidth: 2,
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "rgba(255,255,255,0.8)",
                          "&.Mui-focused": { color: "#FFD700" },
                        },
                        "& .MuiInputBase-input": { color: "white" },
                      }}
                    />
                  </Grid>
                </Grid>
              </Stack>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 4, pt: 2 }}>
            {!requestSuccess && (
              <>
                <Button
                  onClick={() => setRequestDialogOpen(false)}
                  sx={{
                    color: "rgba(255,255,255,0.8)",
                    fontWeight: 700,
                    px: 4,
                    py: 1.5,
                    fontSize: "1rem",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.1)",
                    },
                  }}
                >
                  ❌ CANCEL
                </Button>
                <Button
                  onClick={handleSubmitRequest}
                  variant="contained"
                  disabled={
                    requestLoading ||
                    !requestForm.vtcName ||
                    !requestForm.playercount ||
                    !requestForm.discordUsername
                  }
                  sx={{
                    background:
                      "linear-gradient(45deg, #FFD700 0%, #FF9800 100%)",
                    color: "#000",
                    fontWeight: 800,
                    px: 6,
                    py: 2,
                    fontSize: "1rem",
                    borderRadius: 3,
                    boxShadow: "0 8px 24px rgba(255, 215, 0, 0.4)",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    "&:hover": {
                      background:
                        "linear-gradient(45deg, #FF9800 0%, #F57C00 100%)",
                      boxShadow: "0 12px 32px rgba(255, 215, 0, 0.6)",
                      transform: "translateY(-2px)",
                    },
                    "&:disabled": {
                      background: "rgba(255,255,255,0.1)",
                      color: "rgba(255,255,255,0.3)",
                    },
                  }}
                >
                  {requestLoading ? (
                    <CircularProgress size={24} sx={{ color: "#000" }} />
                  ) : (
                    "🚀 SUBMIT REQUEST"
                  )}
                </Button>
              </>
            )}

            {requestSuccess && (
              <Button
                onClick={() => setRequestDialogOpen(false)}
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(45deg, #4CAF50 0%, #66BB6A 100%)",
                  color: "white",
                  fontWeight: 800,
                  px: 6,
                  py: 2,
                  fontSize: "1rem",
                  borderRadius: 3,
                  boxShadow: "0 8px 24px rgba(76, 175, 80, 0.4)",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #66BB6A 0%, #4CAF50 100%)",
                    boxShadow: "0 12px 32px rgba(76, 175, 80, 0.6)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                🎉 CLOSE
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Container>

      {approvedBookings.length > 0 && (
        <Box sx={{ px: { xs: 2, md: 4 }, pb: 6, maxWidth: 1280, mx: "auto" }}>
          <Typography
            variant="h5"
            sx={{ color: "rgba(255,255,255,0.95)", fontWeight: 600, mb: 2 }}
          >
            Confirmed bookings
          </Typography>
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              background: "rgba(0, 0, 0, 0.35)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "rgba(255, 215, 0, 0.15)" }}>
                  <TableCell sx={{ fontWeight: 700, color: "#FFD700" }}>VTC</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: "#FFD700" }}>Route</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: "#FFD700" }}>Slot</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {approvedBookings.map((item) => (
                  <TableRow
                    key={item._id}
                    hover
                    sx={{
                      "&:nth-of-type(even)": { bgcolor: "rgba(255,255,255,0.02)" },
                      "&:hover": { bgcolor: "rgba(255,255,255,0.05)" },
                    }}
                  >
                    <TableCell sx={{ color: "#fff", fontWeight: 500 }}>
                      {item.vtcName}
                    </TableCell>
                    <TableCell sx={{ color: "rgba(255,255,255,0.85)" }}>
                      {item.routeName || "—"}
                    </TableCell>
                    <TableCell sx={{ color: "rgba(255,255,255,0.85)" }}>
                      {item.allocatedSlotName
                        ? `${item.allocatedSlotName}${item.allocatedSlotNumber ? ` (#${item.allocatedSlotNumber})` : ""}`
                        : "—"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
};

export default SpecialEvent;
